module.exports = __webpack_public_path__ + "static/rocket-30601e725d6703ebf63cc78e27b5b936.svg";